import { useParams, useNavigate, useLocation } from 'react-router';
import CalendarEvent from './CalendarEvent';

const HolidayPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  // Get the redirect path from location state, or default to /Calendar/Holidays
  const handleClose = () => {
    const redirectPath = location.state?.from || '/Calendar/Holidays';
    navigate(redirectPath);
  };

  return (
        <CalendarEvent 
        closeModal={handleClose} 
        eventId={id ? parseInt(id) : null} 
        updateEvents={handleClose}
        />
    );
};

export default HolidayPage;

